import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";     // ✅ important
import App from "./App";

// console.log("Loaded ENV:", process.env);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
